import { render } from "./QuizNow.vue?vue&type=template&id=12834ce1"
import script from "./QuizNow.vue?vue&type=script&lang=js"
export * from "./QuizNow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__